export const HamburgerIcon = () => (
  <span className="hamburger-icon">
    <span className="icon-bar" />
    <span className="icon-bar" />
    <span className="icon-bar" />
  </span>
);
